import { blue, green, indigo, maconia, purple } from "./colors";

import type { PaletteColor } from "@mui/material/styles/createPalette";
import type { ColorPreset } from "./index";

export const getPrimary = (preset?: ColorPreset): PaletteColor => {
	switch (preset) {
		case "blue":
			return blue;
		case "green":
			return green;
		case "indigo":
			return indigo;
		case "purple":
			return purple;
		case "maconia":
		// Legacy preset name, same palette.
		case "browserbite":
			return maconia;
		default:
			console.error(
				'Invalid color preset, accepted values: "maconia", "blue", "green", "indigo" or "purple".'
			);

			return maconia;
	}
};
